import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40d2f074"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidebar" }
const _hoisted_2 = {
  key: 0,
  class: "bu-switcher"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-building fa-fw" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "label" }, "apps", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "far fa-fw fa-shapes" }, null, -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Installed Apps")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "far fa-fw fa-cart-shopping" }, null, -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" App Store")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-fw fa-plug" }, null, -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" External Systems")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "label" }, "automations", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "far fa-fw fa-diagram-project" }, null, -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Flows")
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "far fa-fw fa-files" }, null, -1))
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Content")
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "space" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "label" }, "administration", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "far fa-fw fa-bug" }, null, -1))
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" API Debugger")
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "far fa-fw fa-webhook" }, null, -1))
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" WebHooks")
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "far fa-fw fa-buildings" }, null, -1))
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Business Units")
const _hoisted_24 = { key: 4 }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "far fa-fw fa-users" }, null, -1))
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Users")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_business_unit_switcher = _resolveComponent("business-unit-switcher")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      (_ctx.businessUnits && _ctx.businessUnits.length > 0)
        ? (_openBlock(), _createElementBlock("li", _hoisted_2, [
            _createElementVNode("button", {
              class: "btn btn-darklight btn-businessunit-switch w-100",
              type: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectBusinessUnit = true))
            }, [
              _createTextVNode(_toDisplayString(_ctx.currentBusinessUnitName) + " ", 1),
              _hoisted_3
            ])
          ]))
        : _createCommentVNode("", true),
      _hoisted_4,
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          to: { name: 'apps-installed' },
          "active-class": "active",
          tag: "a"
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _hoisted_6
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          to: { name: 'apps-store' },
          "active-class": "active",
          tag: "a"
        }, {
          default: _withCtx(() => [
            _hoisted_7,
            _hoisted_8
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          to: { name: 'external-systems' },
          "active-class": "active",
          tag: "a"
        }, {
          default: _withCtx(() => [
            _hoisted_9,
            _hoisted_10
          ]),
          _: 1
        })
      ]),
      (_ctx.isAdmin)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _hoisted_11,
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: { name: 'automation-flows' },
                "active-class": "active",
                tag: "a"
              }, {
                default: _withCtx(() => [
                  _hoisted_12,
                  _hoisted_13
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: { name: 'content' },
                "active-class": "active",
                tag: "a"
              }, {
                default: _withCtx(() => [
                  _hoisted_14,
                  _hoisted_15
                ]),
                _: 1
              })
            ])
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.isAdmin || _ctx.isBusinessUnitAdmin)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _hoisted_16,
            _hoisted_17
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.isAdmin)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: { name: 'sprinklr-api' },
                "active-class": "active",
                tag: "a"
              }, {
                default: _withCtx(() => [
                  _hoisted_18,
                  _hoisted_19
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: { name: 'sprinklr-webhooks' },
                "active-class": "active",
                tag: "a"
              }, {
                default: _withCtx(() => [
                  _hoisted_20,
                  _hoisted_21
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: { name: 'manage-businessunits' },
                "active-class": "active",
                tag: "a"
              }, {
                default: _withCtx(() => [
                  _hoisted_22,
                  _hoisted_23
                ]),
                _: 1
              })
            ])
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.isAdmin || _ctx.isBusinessUnitAdmin)
        ? (_openBlock(), _createElementBlock("li", _hoisted_24, [
            _createVNode(_component_router_link, {
              to: { name: 'manage-users' },
              "active-class": "active",
              tag: "a"
            }, {
              default: _withCtx(() => [
                _hoisted_25,
                _hoisted_26
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.selectBusinessUnit)
      ? (_openBlock(), _createBlock(_component_business_unit_switcher, {
          key: 0,
          title: "Select Customer",
          onCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectBusinessUnit = false)),
          onSelect: _ctx.updateCurrentBusinessUnit,
          "business-units": _ctx.businessUnits,
          "current-business-unit": _ctx.currentBusinessUnit
        }, null, 8, ["onSelect", "business-units", "current-business-unit"]))
      : _createCommentVNode("", true)
  ]))
}